import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import { useProvider, Toast } from '../../context/MenuProvider';


import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';

const SelecionarTipoCategoria = ({tipo, setTipo, defaultText, label, adicionalText, adicionalValue, obrigatorio, multiplos}) => {
  const { hasPerms } = useProvider();
  return (
    <>
      <Form.Group controlId="formTipoCategoria">
        <div className="input-group">
          <span className="input-group-text">{label || 'Tipo'} {obrigatorio && ("*")}</span>
          <Form.Control
            as="select"
            value={tipo}
            multiple={multiplos}
            onChange={(e) => {
              if (multiplos) {
                const values = Array.from(e.target.selectedOptions, opt => opt.value);
                setTipo(values);
              } else {
                setTipo(e.target.value);
              }
            }}
          >
            {!multiplos && (<option value="">{defaultText}</option>)}
            {hasPerms(['loja.view_produtos']) && (<option value="produtos">Produtos</option>)}
            {hasPerms(['loja.view_cobranca']) && (<option value="cobranca">Tipos de Cobrança</option>)}
            {hasPerms(['core.view_contato']) && (<option value="tags">Tags</option>)}
            {hasPerms(['rede.view_apn']) && (<option value="rede">Rede</option>)}
            {hasPerms(['financas.view_financeiro']) && (<>
              <option value="pessoais">Despesas pessoais</option>
              <option value="negocio">Custos do negócio</option>
            </>)}
            
            
            
            {adicionalText &&
              (<option value={adicionalValue}>{adicionalText || 'Tipo Adicional'}</option>)
            }
          </Form.Control>
        </div>
        <div className="small text-muted">
          {tipo === "rede" && (<>Caregorias do módulo de Marketing de Rede</>)}
          {tipo === "venda" && (<>Caregorias do módulo de Vendas</>)}
          {tipo === "produtos" && (<>Categorias do módulo de produtos</>)}
          {tipo === "pessoais" && (<>Categorias do módulo de financas pessoais (Custo de vida)</>)}
          {tipo === "negocio" && (<>Categorias do módulo dos custos do negócio como recompra, custos operacionais etc...</>)}
        </div>
      </Form.Group>
    </>
  );
}

export default SelecionarTipoCategoria;